exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre{overflow:unset;white-space:pre-wrap;font-size:unset;padding:0;margin:0;line-height:unset;color:unset;background-color:unset;border:0 none;border-radius:0}", ""]);

// exports
